<template>
	<div class="simulation">
        <div class="simulation__nav">
            <span @click="mudarAba(1)" :class="{'active':this.aba==1}">
                Resumo previsto do investimento
            </span>
            <span @click="mudarAba(2)" :class="{'active':this.aba==2}" v-if="!this.antecipacaoGambiarra">
                IOUU x CDB
            </span>
            <span @click="mudarAba(3)" :class="{'active':this.aba==3}" v-if="!this.antecipacaoGambiarra">
                Repagamentos
            </span>
        </div>
        <div v-if="aba==1" class="summary">
            <div class="summary__value">
                <small>Valor da oferta</small>
                <input disabled class="summaryInput" v-model="valorMascara" type="text">

            </div>
            <!-- GAMBIARRA ANTECIPACAO -->
            <div class="summary__tax" v-if="this.antecipacaoGambiarra">
                <div class="summary__tax__value">
                    <div>
                        <small>Retorno bruto final do período</small>
                        <span>{{this.taxaGambiarra}}%</span>
                    </div>
                    <div>
                        <small>Retorno Esperado no período</small>
                        <span>{{this.CDIGambiarra}}% CDI</span>
                    </div>
                </div>
            </div>
            <!-- GAMBIARRA ANTECIPACAO -->
            <div class="summary__tax" v-else>
                <div class="summary__tax__value">
                    <div>
                        <small>Taxa interna de retorno</small>
                        <span>{{solicitacao.RetornoBrutoMensal}}% a.m.</span>
                    </div>
                    <div>
                        <small>Taxa total efetiva</small>
                        <span>{{solicitacao.RetornoBrutoAnual}}% a.a.</span>
                    </div>
                </div>
                <small v-if="verificaProduto(solicitacao.CodProduto)" class="summary__tax__footer">* A taxa de juros acima é igual ao seu Retorno Bruto (Retorno antes do desconto de IR).</small>
                <small v-else class="summary__tax__footer">* A taxa de juros acima já é líquida de Imposto de Renda.</small>
            </div>
            <div class="summary__info"  v-if="!this.antecipacaoGambiarra">
                <div class="summary__info__title">
                    Informações Gerais
                </div>
                <ul v-if="verificaProduto(solicitacao.CodProduto)" class="summary__info__table">
                    <li>
                        <div>Plano de pagamento</div>
                        <div>{{solicitacao.Prazo}} parcelas² de R$ {{formataValor(valorParcela)}}³</div>
                    </li>
                    <li>
                        <div>Retorno Bruto</div>
                        <div>R$ {{formataValor(valorBruto)}}</div>
                    </li>
                    <li>
                        <div>Imposto de renda total</div>
                        <div>R$ {{formataValor(CalculosSimulados.IR)}}</div>
                    </li>
                    <li>
                        <div>Retorno líquido</div>
                        <div>R$ {{formataValor(valorLiquido)}}</div>
                    </li>
                </ul>
                <ul v-else class="summary__info__table">
                    <li>
                        <div>Plano de pagamento</div>
                        <div>{{solicitacao.Prazo}} parcelas² de R$ {{formataValor(valorParcela)}}³</div>
                    </li>
                    <li v-if="verificaProduto(solicitacao.CodProduto)">
                        <div>Retorno Bruto</div>
                        <div>R$ {{formataValor(valorBruto)}}</div>
                    </li>
                    <li>
                        <div>Imposto de renda total</div>
                        <div>R$ 0</div>
                    </li>
                    <li>
                        <div>Retorno líquido</div>
                        <div>R$ {{formataValor(valorBruto)}}</div>
                    </li>
                </ul>
                <div class="summary__info__footer">
                    <span>
                        ² Pagamento da primeira parcela: aproximadamente 1 mês depois da assinatura dos contratos.<br/>
                    </span>
                </div>
            </div>
        </div>

        <div v-if="aba==2" class="graph">
            <div class="graph__value">
                <span>Valor da oferta</span><input disabled v-model="valorMascara" class="simulatedVal" type="text">
            </div>
            <div class="graph__draw">
                <Chart :parcelas="parcelas" :parcelasCDI="parcelasCDI" :valor="valorFormatado" :width="840" :height="320"/>
            </div>
            <span class="graph__footer">
                *Valores aproximados em duas casas decimais para melhor visualização. <br/>
                CDB de 100% do CDI (consulta: 27/08/2019) - Fonte: B3.
            </span>
        </div>

        <div v-if="aba==3" class="cashflow">
            <div class="cashflow__value">
                <span>Valor da oferta</span>
                <input disabled v-model="valorMascara" placeholder="R$ 2.000,00" type="text">
            </div>
            <div class="cashflow__table">
                <div class="cashflow__table__header">
                    <div>Mês</div>
                    <div>Parcela Liquida</div>
                    <div>Amortização</div>
                    <div>Juros</div>
                    <div>IR</div>
                    <div>Saldo Devedor</div>
                </div>
                <ul v-if="verificaProduto(solicitacao.CodProduto)" class="cashflow__table__content">
                    <li v-for="item in CalculosSimulados.tabela" :key="item.parcela">
                        <div>Mês {{item.parcela}}</div>
                        <div>R$ {{formataValor(item.parcelaLiquida)}}</div>
                        <div>R$ {{formataValor(item.amortizado)}}</div>
                        <div>R$ {{formataValor(item.juros)}}</div>
                        <div>- R$ {{formataValor(item.IR)}}</div>
                        <div>R$ {{formataValor(item.valorFinanciado)}}</div>
                    </li>
                </ul>
                <ul v-else class="cashflow__table__content">
                   <li v-for="item in CalculosSimulados.tabela" :key="item.parcela">
                        <div>Mês {{item.parcela}}</div>
                        <div>R$ {{valorBrutoAmortizado(item.amortizado, item.juros)}}</div>
                        <div>R$ {{formataValor(item.amortizado)}}</div>
                        <div>R$ {{formataValor(item.juros)}}</div>
                        <div>R$ 0</div>
                        <div>R$ {{formataValor(item.valorFinanciado)}}</div>
                    </li> 
                </ul>
            </div>
            <div class="cashflow__footer">
                <span>
                    *Valores aproximados em duas casas decimais para melhor visualização. O fluxo de repagamentos é calculado pela Tabela Price, caracterizada por pagamentos mensais iguais embutindo uma amortização crescente e juros decrescente.
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    import Chart from '../charts/LineChartInvestment';
    import Calculos from '../../mixins/Calculos';
	import Masker from '../../utils/masker';

    export default {
        mixins: [Calculos],
        data(){
            return{
                aba:1,
                editavel:false,
                antecipacaoGambiarra: false,
				taxaGambiarra: 5.26,
				CDIGambiarra: 641.46
            }
        },
        props:{
            valor: { type:String },
            solicitacao: { type:Object },
        },
        components:{
            Chart
        },
        computed:{
            parcelas(){
                let parcelas = [], valorAcumulativo = this.valorFormatado
                this.CalculosSimulados.tabela.forEach(element => {
                    valorAcumulativo = parseFloat((valorAcumulativo + parseFloat(element.juros)).toFixed(2))
                    parcelas = [...parcelas, { mes: element.parcela, valorAcumulativo }]
                });
                for (let i = 1; i <= this.solicitacao.Prazo; i++) {
                }
                return parcelas
            },
            parcelasCDI(){
				let cdi = 0.059
                let parcelas = [], valorAcumulativo = this.valorFormatado
                let juros = this.valorFormatado * cdi
                for (let i = 1; i <= this.solicitacao.Prazo; i++) {
                    valorAcumulativo = parseFloat((valorAcumulativo + juros/12 ).toFixed(2))
                    parcelas = [...parcelas, { mes: i, valorAcumulativo }]
                }
                return parcelas
            },
            valorParcela(){
                let parcela = this.PMT(this.valorFormatado, this.solicitacao.RetornoBrutoMensal/100, this.solicitacao.Prazo)
                return parseFloat(parcela.toFixed(2))
            },
            valorBruto(){
                let bruto = this.valorParcela * this.solicitacao.Prazo
                return parseFloat(bruto.toFixed(2))
            },
            valorLiquido(){
                let liquido = this.valorBruto - parseFloat(this.CalculosSimulados.IR)
                return parseFloat(liquido.toFixed(2))
            },
            valorFormatado(){
                console.log(typeof this.valor);
                return typeof this.valor == 'string' ? Masker.unmaskMoney(this.valor) : this.valor
            },
            valorMascara(){
                return 'R$ ' + this.valorFormatado + ',00'
            },
            CalculosSimulados(){
                let calculos = this.GerarCalculos(this.valorFormatado, this.solicitacao.RetornoBrutoMensal/100, this.solicitacao.Prazo)

                console.log(calculos)

                return calculos
            }
        },
        methods:{
            mudarAba(aba){
                this.aba = aba
            },
            editarValor(status){
                this.editavel = status
            },
            formataValor(valor){
                if(valor.toString().indexOf('.') == -1){
                    valor = valor + '.00'
                }
                return Masker.maskMoney(valor.toString())
            },
            removeMascara(valor){
                return Masker.unmaskMoney(valor.replace('R$ ',''))
            },
            totalEmprestimos(Prazo, ValorParcela){
                return this.formataValor(Prazo * Math.floor(ValorParcela*100)/100)
            },
            verificaProduto(produto) {
                
                if(produto != "EMPRES") {
                    return true
                }

                return false
            },
            valorBrutoAmortizado(valor, juros) {
                let valorBruto = parseFloat(valor) + parseFloat(juros)
                
                return this.formataValor(valorBruto)
            }
        },
        created() {
			if(this.solicitacao._id === "5e9de72f796877415093cb1d" || this.solicitacao._id === "5ea348604e46501f80f6641f") this.antecipacaoGambiarra = true;
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/styles/iouu/variables";
	@import "../../assets/styles/iouu/mixins";

    small{
        color:#888888;
        font-size:11px;
    }

    .simulation{
        &__nav{
            display:flex;
            color:#999999;
            font-size: 15px;
            font-weight: bold;

            & > span{
                cursor:pointer;
                flex:1;
                text-align: center;
                box-sizing: border-box;
                border-bottom:2px solid #DDDDDD;

                &.active {
                    flex:1;
                    color:#000;
                    font-weight: bold;
                    border-bottom:2px solid #41D3BD;
                }
            }
        }
    }

    @media screen and (max-width: 1220px) {
        .simulation__nav {
            display: none;
        }
    }

    // Aba de resumo
    .summary{
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        &__value{
            padding: 18px;
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-bottom:1px solid #DDDDDD;

            & > input{
                width: 16ch;
                margin:0px;
                padding:0px;
                font-size:22px;
                font-weight: bold;
                text-align: center;
                border-radius:5px;
            }
        }

        &__tax{
            padding: 20px;
            display:flex;
            flex-direction: column;
            align-items: center;
            border-bottom:1px solid #DDDDDD;

            &__value{
                display:flex;

                & > div{
                    display:flex;
                    padding:0px 10px;
                    text-align: center;
                    flex-direction: column;

                    & > span{
                        font-size:22px;
                        font-weight: bold;
                    }
                }
            }

            &__footer{
                font-size:10px;
            }
        }

        &__info{
            margin:15px 0px;

            &__title{
                font-size:18px;
                font-weight: bold;
                padding-bottom:8px;
            }

            &__table{
                list-style-type: none;
                border: 1px solid #DDDDDD;
                border-radius: 5px;

                & > li{
                    font-size:14px;
                    color:#999999;
                    padding: 8px;
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid #DDDDDD;

                    &:last-child{
                        border-bottom:none;
                    }

                    & > div:nth-child(even){
                        font-weight: bold;
                        color:#000;
                    }
                }
            }
            &__footer{
                font-size:10px;
                color:#888888;
                text-align: center;
                & > span{
                    display:inline-block;
                    max-width: 500px;
                }
            }
        }
    }

    // Aba IOUU x CDB
    .graph{
        display:flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;

        &__value{
            display:flex;
            text-align: center;
            justify-content: center;
            font-weight: bold;
            margin:20px 0px;

            & > span{
                font-size: 11px;
                color:#888888;
            }

            & > input{
                width: 140px;
                height: 22px;
                font-weight: bold;
                text-align: center;
                margin-left:11px;
                margin-bottom:0px;
                font-size: 14px;
            }
        }

        &__draw{
            margin:auto;
            max-width: 840px;
            max-height: 320px;
        }

        &__footer{
            font-size: 10px;
            margin:15px;
        }
    }

    // Aba Repagamentos
    .cashflow{
        margin-top: 20px;
        margin-bottom: 20px;

        &__value{
            display:flex;
            text-align: center;
            justify-content: center;
            font-weight: bold;
            margin:15px 0px;

            & > span{
                font-size: 11px;
                color:#888888;
            }

            & > input{
                width: 140px;
                height: 22px;
                font-weight: bold;
                text-align: center;
                margin-left:11px;
                margin-bottom:0px;
                font-size: 14px;
            }
        }

        &__table{
            list-style-type: none;

            &__header{
                display: flex;
                padding: 5px 10px;
                margin-right: 20px;
                border-bottom: 2px solid #ccc;

                & > div{
                    flex:1;
                    text-align: center;
                    flex-wrap: nowrap;
                    font-size:12px;
                    font-weight: bold;
                }
            }

            &__content{
                font-size:12px;
                color: #999;
                max-height: 290px;
                overflow-x: none;
                overflow-y: auto;

                // Scrollbar
                /* width */
                &::-webkit-scrollbar {
                    width: 8px;
                }
                /* Track */
                &::-webkit-scrollbar-track {
                    background: #F1F1F1; 
                    border-radius: 10px;
                }
                /* Handle */
                &::-webkit-scrollbar-thumb {
                    background: #41D3BD; 
                    border-radius: 10px;
                }

                & > li{
                    padding: 5px 10px;
                    margin-right: 15px;
                    display: flex;
                    justify-content: space-between;
                    text-align: center;
                    border-bottom: 1px solid #ccc;

                    & > div{
                        flex:1
                    }
                }

            }
        }
        &__footer{
            font-size:10px;
            text-align: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/NewModal/Simulation.vue